import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';

import { ROUTE } from 'common/const';

import PrivateRoute from './PrivateRoute';
import { Account } from './account';
import { BoothSetup, EventSearch, NewOrder, ReuseOrder } from './booth-setup';
import { Login, Signup, SSO } from './onboarding';
import {
  CancelOrder,
  Dashboard,
  OrderDetails,
  OrderHistory,
  OrderInvoice,
  ReviseOrder,
} from './orders';
import Shopping from './shopping';
import Checkout, { Confirmation, QuestionsPostOrder } from './checkout';
import FloorPlanBuilder from './floor-plan-builder';
import { NotFound, Faq } from './info';

const Routes = () => {
  return (
    <Router>
      <Switch>
        {/* onboarding */}
        <Route path={ROUTE.LOGIN} component={Login} />
        <Route path={ROUTE.SIGNUP} component={Signup} />
        <Route path={ROUTE.SSO} component={SSO} />

        {/* account */}
        <PrivateRoute path={ROUTE.ACCOUNT} component={Account} />

        {/* orders */}
        <PrivateRoute path={ROUTE.DASHBOARD} component={Dashboard} />
        <PrivateRoute path={ROUTE.ORDERS} component={OrderHistory} />
        <PrivateRoute
          path={ROUTE.ORDER_DETAILS + '/:id'}
          component={OrderDetails}
        />
        <PrivateRoute
          path={ROUTE.ORDER_INVOICE + '/:id'}
          // path={ROUTE.ORDER_INVOICE + '/:id/:empOrderId'}
          component={OrderInvoice}
        />
        <PrivateRoute path={ROUTE.CANCEL + '/:id'} component={CancelOrder} />
        <PrivateRoute
          path={ROUTE.REVISE_ORDER + '/:id'}
          component={ReviseOrder}
        />

        {/* select event */}
        <PrivateRoute path={ROUTE.NEW_ORDER} component={NewOrder} />
        <PrivateRoute
          path={ROUTE.EVENT_SEARCH + '/:filter/:value'}
          component={EventSearch}
        />
        <PrivateRoute path={ROUTE.EVENT_SEARCH} component={EventSearch} />

        {/* booth setup */}
        <PrivateRoute
          path={[ROUTE.RESUME_ORDER, ROUTE.START_ORDER, ROUTE.BOOTH_SETUP]}
          component={BoothSetup}
        />

        {/* reuse order */}
        <PrivateRoute path={ROUTE.REUSE_ORDER} component={ReuseOrder} />

        {/* shopping */}
        <PrivateRoute path={ROUTE.SHOPPING} component={Shopping} />

        <PrivateRoute
          path={ROUTE.FLOOR_PLAN_BUILDER}
          component={FloorPlanBuilder}
        />

        {/* checkout */}
        <PrivateRoute path={ROUTE.CHECKOUT} component={Checkout} />
        <PrivateRoute
          path={ROUTE.CONFIRMATION + '/:id'}
          component={Confirmation}
        />
        <PrivateRoute path={ROUTE.POST_ORDER} component={QuestionsPostOrder} />

        {/* misc */}
        <PrivateRoute path={ROUTE.HOME} exact>
          <Redirect to={ROUTE.DASHBOARD} />
        </PrivateRoute>
        <PrivateRoute path={ROUTE.FAQ} component={Faq} />
        <Route default component={NotFound} />
      </Switch>
    </Router>
  );
};

export default Routes;
